import React from 'react';
import { bool, node, string } from 'prop-types';
import classNames from 'classnames';
import { Tooltip } from '@fiverr-private/fit';
import { getContext } from '@fiverr-private/fiverr_context';
import { contextConnect } from '../Context';

import './index.scss';

const CollectTooltip = ({
    children,
    content,
    tooltipClassName,
    showTooltip = true
}) => {
    const { isTouch } = getContext();

    return (
        isTouch ?
            <>
                { children }
            </> :
            <Tooltip content={showTooltip ? content : null}
                boxContentClassName="tooltip-box-content"
                containerClassName={classNames('collect-package-tooltip', tooltipClassName)}>
                {children}
            </Tooltip>
    );
};

CollectTooltip.propTypes = {
    children: node,
    content: node,
    tooltipClassName: string,
    showTooltip: bool
};

export { CollectTooltip };
export default contextConnect()(CollectTooltip);
